<script setup lang="ts">
import { computed } from 'vue'
import { itemScopeAttributes, useModelStrings, type ItemTemplateProps } from '@jantm/model-core'
import type {Offer} from "@/types/Wiser/offer.ts";
import {useRouter} from "vue-router";

/**
 * Custom item rendering for Offer.
 *
 * Narrowing `entity` to `Offer` is the whole point of a per-model template: the
 * props contract stays the one model-core passes, but inside this file the
 * entity is fully typed.
 */
const props = withDefaults(defineProps<ItemTemplateProps<Offer>>(), { headingLevel: 3 })

const { t, locale } = useModelStrings(() => props.definition)

const scope = computed(() => itemScopeAttributes(props.definition))
const heading = computed(() => `h${props.headingLevel}` as const)
const router = useRouter()
const entityId = computed(() => props.entity?.id ?? 0)
const gotoDetail = function() {
  router.push({name: 'wiser-offer', params: {id: entityId.value}})
}
</script>

<template>
  <article
    class="wiser-item offer-item"
    v-bind="scope"
    @click="gotoDetail"
  >
    <component
      :is="heading"
      class="wiser-item__title offer-item__title"
    >
      <span>{{ entity.id }}</span>
      <span class="wiser-item__badge offer-item__badge">{{ entity.offertestatus }}</span>
    </component>
    <span>{{ entity.offertedatum }}</span>
    <span>{{ entity.korteomschrijving }}</span>
  </article>
</template>
